import React from 'react';
import classNames from 'classnames';
import { toast } from 'react-hot-toast';
import { Button } from '@salesforce/design-system-react';
import { Link } from 'react-router-dom';
import { getNumbersWithDecimalPlaces } from '../../../utilities/money';

const SentDetails = ({ data = [], linkTo }) => {
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    toast.success('Successfully Copied');
  };

  return (
    <>
      {data.length > 0 && (
        <div>
          {data.map((card, index) => (
            <div
              key={index}
              className={classNames(
                'slds-grid slds-grid_pull-padded slds-grid_vertical-align-center home_card'
              )}
            >
              <div className="transaction_detail_half_details">
                <div className="flex items-center">
                  <span>
                    Amount:{' '}
                    <span style={{ fontWeight: '700' }}>
                      {getNumbersWithDecimalPlaces(card?.amount || 0)}
                    </span>
                  </span>
                  <span
                    style={{
                      marginLeft: 10,
                      padding: '2px 5px',
                      borderRadius: 5,
                      border: '1px solid gray'
                    }}
                  >
                    Sent
                  </span>
                </div>
                <span title={card.to_addr_name} className="hover:cursor-pointer">
                  To: {card.to_addr_name}
                </span>
              </div>
              <div
                className="transaction_detail_half_details"
                style={{
                  marginRight: '15px',
                  textAlign: 'right',
                }}
              >
                <Button
                  style={{ marginRight: 12, marginBottom: 10 }}
                  key="copy"
                  label="Copy"
                  onClick={() => handleCopy(card.to_addr)}
                  iconCategory="utility"
                  iconName="copy"
                  iconPosition="left"
                />
                <Link to={`${linkTo}/${card.to_addr}`} target="_blank" rel="noopener noreferrer">
                  <Button
                    key="navigate"
                    label="Navigate"
                    iconCategory="utility"
                    iconName="link"
                    iconPosition="left"
                  />
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default SentDetails;
